interface Error {
    statusCode: string;
}

export default function HandleError(e: Error) {
    if (process.env.NODE_ENV === "production") {
        window.location.href = "/error/" + e.statusCode;
    } else {
        console.error(e);
    }
}
